(() => {
  'use strict';

  const VERSION = '2026-08-17-unified-drawer-v26.1';
  const SECTION = '.faire-dawn-header-section';
  const DATA_ID = 'dd-cascade-mega-data-v18';
  const MOBILE = '(max-width: 989px)';
  const boundBodies = new WeakSet();

  if (window.__ddNordicMobileV22 === VERSION) return;
  window.__ddNordicMobileV22 = VERSION;

  const norm = v => String(v || '').trim().toLocaleLowerCase('tr-TR');
  const el = (tag, cls, text) => {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  };

  function parseData() {
    const src = document.getElementById(DATA_ID);
    if (!src) return null;
    try { return JSON.parse(src.textContent || '{}'); }
    catch (_) { return null; }
  }

  function parseHeaderConfig(section) {
    const id = section?.getAttribute('data-section-id');
    const src = id ? document.getElementById(`faire-dawn-config-${id}`) : null;
    if (!src) return {};
    try { return JSON.parse(src.textContent || '{}'); }
    catch (_) { return {}; }
  }

  function cleanRoot(root) {
    if (!root) return root;
    const copy = { ...root, children: Array.isArray(root.children) ? root.children.map(x => ({ ...x })) : [] };
    if (norm(copy.title) === 'sanat') {
      copy.children = copy.children.filter(x => norm(x.title) !== 'sanatçılar' && norm(x.title) !== 'sanatcilar');
    }
    return copy;
  }

  function rootKey(root) {
    return norm(root?.key || root?.title).replace(/ı/g,'i').replace(/ğ/g,'g').replace(/ü/g,'u').replace(/ş/g,'s').replace(/ö/g,'o').replace(/ç/g,'c');
  }

  function deepChildren(data, root, level1, level2) {
    const groups = Array.isArray(data?.deep?.[rootKey(root)]) ? data.deep[rootKey(root)] : [];
    const wanted = norm(level2?.title);
    const wantedPath = `${norm(level1?.title)} > ${wanted}`;
    const exact = groups.find(g => norm(g.path) === wantedPath || norm(g.path) === wanted);
    if (exact && Array.isArray(exact.children)) return exact.children;
    const loose = groups.find(g => norm(g.path).endsWith(`> ${wanted}`) || norm(g.path).includes(wanted));
    return Array.isArray(loose?.children) ? loose.children : [];
  }

  function childrenFor(data, item, depth, ctx) {
    if (depth <= 1) return Array.isArray(item?.children) ? item.children : [];
    if (depth === 2 && ctx.root && ctx.level1) return deepChildren(data, ctx.root, ctx.level1, item);
    return Array.isArray(item?.children) ? item.children : [];
  }

  function nextContext(ctx, item, depth) {
    if (depth === 0) return { root: item };
    if (depth === 1) return { ...ctx, level1: item };
    if (depth === 2) return { ...ctx, level2: item };
    return { ...ctx };
  }

  function otherLinks() {
    return [
      { title: 'Yeni', url: '/collections/all?sort_by=created-descending' },
      { title: 'Hediyeler', url: '/pages/hediye-rehberi' },
      { title: 'Tasarımcılar', url: '/pages/tasarimcilar' },
      { title: 'Özel Fırsatlar', url: '/collections/sale' },
      { title: 'İlham', url: '/blogs/ilham' },
      { title: 'Çok Satanlar', url: '/collections/all?sort_by=best-selling' },
      { title: 'Tüm Koleksiyonlar', url: '/collections/all' }
    ];
  }

  function socialSvg(key) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    const k = norm(key);
    if (k.includes('instagram')) {
      svg.innerHTML = '<rect x="3.5" y="3.5" width="17" height="17" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" class="ddmm22__social-dot"/>';
    } else if (k.includes('linkedin')) {
      svg.innerHTML = '<path d="M6 9v10M6 5.5v.1M10.5 19v-5.6c0-2.7 4.2-3 4.2 0V19M10.5 9v10M18 19v-6.2c0-5.1-5.4-5.5-7.5-2.5"/>';
    } else if (k.includes('facebook')) {
      svg.innerHTML = '<path d="M14 8h3V4h-3c-3 0-5 2-5 5v3H6v4h3v5h4v-5h3l1-4h-4V9c0-.7.3-1 1-1Z"/>';
    } else if (k === 'x' || k.includes('twitter')) {
      svg.innerHTML = '<path d="M5 4 19 20M19 4 5 20"/>';
    } else if (k.includes('pinterest')) {
      svg.innerHTML = '<circle cx="12" cy="12" r="8.5"/><path d="M10.4 17.5 12 10.7c.4-1.7 3-1.2 2.6.8-.4 2-1.5 3.3-3 3.3-2 0-3.3-1.7-3.3-3.9 0-3 2.4-5.2 5.7-5.2 2.7 0 4.8 1.9 4.8 4.5 0 3.4-1.9 5.9-4.7 5.9"/>';
    } else if (k.includes('tiktok')) {
      svg.innerHTML = '<path d="M14 4v10.2a4.2 4.2 0 1 1-3.5-4.1M14 4c.6 2.5 2.1 3.8 4.5 4.2"/>';
    } else {
      svg.innerHTML = '<circle cx="12" cy="12" r="8.5"/><path d="M8 12h8M12 8l4 4-4 4"/>';
    }
    return svg;
  }

  function buildSocialBlock(section) {
    const config = parseHeaderConfig(section);
    const mobile = config.mobile || {};
    if (mobile.showSocial === false) return null;
    const rootUrl = String((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/');
    let links = (Array.isArray(mobile.socialLinks) ? mobile.socialLinks : []).filter(item => {
      const url = String(item?.url || '').trim();
      return item?.label && url && url !== '/' && url !== rootUrl;
    });

    /* Footer currently defines these platforms but no URLs. Keep them visible and non-clickable instead of inventing accounts. */
    if (!links.length) {
      links = [
        { key: 'instagram', label: 'Instagram', url: '' },
        { key: 'x', label: 'X', url: '' },
        { key: 'linkedin', label: 'LinkedIn', url: '' }
      ];
    }

    const wrap = el('div', 'ddmm22__social');
    wrap.appendChild(el('div', 'ddmm22__social-title', mobile.socialTitle || 'Bizi takip et'));
    const list = el('div', 'ddmm22__social-list');
    links.forEach(item => {
      const hasUrl = Boolean(String(item.url || '').trim());
      const link = el(hasUrl ? 'a' : 'div', `ddmm22__social-link${hasUrl ? '' : ' is-disabled'}`);
      if (hasUrl) {
        link.href = item.url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
      } else {
        link.setAttribute('aria-disabled', 'true');
      }
      const icon = el('span', 'ddmm22__social-icon');
      icon.appendChild(socialSvg(item.key || item.label));
      link.append(icon, el('span', 'ddmm22__social-label', item.label));
      list.appendChild(link);
    });
    wrap.appendChild(list);
    return wrap;
  }

  function buildArrow() {
    const b = el('button', 'ddmm22__arrow');
    b.type = 'button';
    b.setAttribute('aria-label', 'Alt menüyü aç');
    b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg>';
    return b;
  }

  function buildRow(data, item, depth, ctx, onOpen) {
    const row = el('div', 'ddmm22__row');
    const link = el('a', 'ddmm22__link', item.title || '');
    link.href = item.url || '#';
    row.appendChild(link);
    const kids = childrenFor(data, item, depth, ctx);
    if (kids.length) {
      const arrow = buildArrow();
      arrow.addEventListener('click', ev => {
        ev.preventDefault();
        ev.stopPropagation();
        onOpen(item, depth, ctx);
      });
      row.appendChild(arrow);
    }
    return row;
  }

  function buildUnified(section, data) {
    const body = section.querySelector('.faire-site-header__drawer-body');
    if (!body || boundBodies.has(body)) return;
    const existing = body.querySelector(':scope > .ddmm22');
    if (existing) {
      boundBodies.add(body);
      section.classList.add('ddmm22-ready', 'ddmm26-ready');
      existing.classList.add('ddmm26');
      return;
    }

    boundBodies.add(body);
    section.classList.add('ddmm22-ready', 'ddmm26-ready');
    const menu = el('div', 'ddmm22 ddmm26');
    menu.setAttribute('data-dd-mobile-nordic-v22', 'true');
    menu.setAttribute('data-dd-unified-v26', 'true');

    const tabs = el('div', 'ddmm22__tabs');
    const productsTab = el('button', 'ddmm22__tab is-active', 'Ürünler');
    const otherTab = el('button', 'ddmm22__tab', 'Diğer');
    productsTab.type = otherTab.type = 'button';
    productsTab.setAttribute('aria-pressed', 'true');
    otherTab.setAttribute('aria-pressed', 'false');
    tabs.append(productsTab, otherTab);

    const viewport = el('div', 'ddmm22__viewport');
    const stage = el('div', 'ddmm22__stage');
    viewport.appendChild(stage);
    menu.append(tabs, viewport);
    body.appendChild(menu);

    const roots = (Array.isArray(data.roots) ? data.roots : []).map(cleanRoot).filter(Boolean);
    const history = [];
    let rootMode = 'products';

    function animateSwap(build, direction) {
      stage.classList.remove('is-forward', 'is-back');
      stage.classList.add(direction === 'back' ? 'is-back' : 'is-forward');
      requestAnimationFrame(() => {
        stage.replaceChildren();
        build();
        stage.scrollTop = 0;
        requestAnimationFrame(() => stage.classList.remove('is-forward', 'is-back'));
      });
    }

    function renderRoot() {
      stage.replaceChildren();
      stage.appendChild(el('div', 'ddmm22__title', rootMode === 'products' ? 'Koleksiyonlar' : 'Diğer'));
      const list = el('div', 'ddmm22__list');
      const items = rootMode === 'products' ? roots : otherLinks();
      items.forEach(item => {
        if (rootMode === 'products') {
          list.appendChild(buildRow(data, item, 0, {}, openNode));
        } else {
          const row = el('div', 'ddmm22__row');
          const link = el('a', 'ddmm22__link', item.title);
          link.href = item.url;
          row.appendChild(link);
          list.appendChild(row);
        }
      });
      stage.appendChild(list);
      if (rootMode === 'other') {
        const social = buildSocialBlock(section);
        if (social) stage.appendChild(social);
      }
    }

    function renderNode(entry) {
      stage.replaceChildren();
      const bar = el('div', 'ddmm22__drill-head');
      const back = el('button', 'ddmm22__back', 'Geri');
      back.type = 'button';
      back.setAttribute('aria-label', 'Önceki menüye dön');
      back.insertAdjacentHTML('afterbegin', '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 5-7 7 7 7"/></svg>');
      const heading = el('div', 'ddmm22__drill-title', entry.item.title || '');
      bar.append(back, heading);
      stage.appendChild(bar);
      if (entry.item.url) {
        const all = el('a', 'ddmm22__all', `Tüm ${entry.item.title}`);
        all.href = entry.item.url;
        stage.appendChild(all);
      }
      const list = el('div', 'ddmm22__list');
      const kids = childrenFor(data, entry.item, entry.depth, entry.ctx);
      const ctx2 = nextContext(entry.ctx, entry.item, entry.depth);
      kids.forEach(child => list.appendChild(buildRow(data, child, entry.depth + 1, ctx2, openNode)));
      stage.appendChild(list);
      back.addEventListener('click', () => {
        history.pop();
        animateSwap(() => history.length ? renderNode(history[history.length - 1]) : renderRoot(), 'back');
      });
    }

    function openNode(item, depth, ctx) {
      const entry = { item, depth, ctx };
      history.push(entry);
      animateSwap(() => renderNode(entry), 'forward');
    }

    function setMode(mode) {
      rootMode = mode;
      history.length = 0;
      productsTab.classList.toggle('is-active', mode === 'products');
      otherTab.classList.toggle('is-active', mode === 'other');
      productsTab.setAttribute('aria-pressed', String(mode === 'products'));
      otherTab.setAttribute('aria-pressed', String(mode === 'other'));
      animateSwap(renderRoot, 'back');
    }

    productsTab.addEventListener('click', () => setMode('products'));
    otherTab.addEventListener('click', () => setMode('other'));
    renderRoot();

    section.addEventListener('click', ev => {
      const target = ev.target instanceof Element ? ev.target : null;
      if (target?.closest('[data-faire-close-drawer],.faire-site-header__drawer-close')) {
        history.length = 0;
        rootMode = 'products';
        productsTab.classList.add('is-active');
        otherTab.classList.remove('is-active');
        productsTab.setAttribute('aria-pressed', 'true');
        otherTab.setAttribute('aria-pressed', 'false');
        renderRoot();
      }
    });
  }

  function scan() {
    const data = parseData();
    if (!data) return;
    document.querySelectorAll(SECTION).forEach(section => buildUnified(section, data));
  }

  let timer = 0;
  const queue = () => {
    clearTimeout(timer);
    timer = setTimeout(scan, 20);
  };

  let observer = null;
  function observeHeaderMounts() {
    if (!observer) observer = new MutationObserver(queue);
    document.querySelectorAll(SECTION).forEach(section => {
      const target = section.querySelector('[data-faire-header-mount]') || section;
      if (target.__ddNordicMobileV22Observed) return;
      target.__ddNordicMobileV22Observed = true;
      observer.observe(target, { childList: true, subtree: true });
    });
  }

  function start() {
    scan();
    observeHeaderMounts();
    window.matchMedia(MOBILE).addEventListener?.('change', queue);
    document.addEventListener('shopify:section:load', () => {
      observeHeaderMounts();
      queue();
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start, { once: true })
    : start();
})();
